import { Observable } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate{

  private userprivileges: any;
  constructor(private router: Router, private toastService: ToastrService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      this.userprivileges = localStorage.getItem('authority');
      this.userprivileges = JSON.parse(this.userprivileges);
      const section = localStorage.getItem("section");

      // console.log(next.data.role);
      for (const r of this.userprivileges){
        // console.log('privileges ',r.privileges.codepriv);
        if (r.privileges.codepriv == next.data.role && r.state) {
          if(r.privileges.codepriv=='cr_colis' && section != 'envoi'){
            return false;
          }else if(r.privileges.codepriv == 'cr_passager' && section != 'guichet'){
            return false;
          }
          return true;
        }
      }

      // navigate to not found page
      this.toastService.error(
        'SVP veillez contacter l\'administrateur pour plus d\'informations',
        'POSTE NON AUTORISE',
        {
          timeOut: 5000,
          progressBar: true,
          positionClass: "toast-bottom-right",
          enableHtml: true,
        }
      );
      return false;
    }
}
